'use client';

import {closeSnackbar, SnackbarProvider} from 'notistack';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

interface CustomSnackbarProviderProps {
    children: React.ReactNode;
}

export default function CustomSnackbarProvider({ children }: CustomSnackbarProviderProps) {
    return (
        <SnackbarProvider
            maxSnack={3}
            autoHideDuration={4000}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            preventDuplicate
            dense
            action={(snackbarId) => (
                <IconButton
                    aria-label="close"
                    onClick={() => closeSnackbar(snackbarId)}
                    size="small"
                    sx={{ color: 'white' }}
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            )}
        >
            {children}
        </SnackbarProvider>
    );
}